import { lazy as reactLazy } from 'react';

const RELOAD_KEY = 'fc_chunk_reload_at';

// Depois de um deploy, uma aba que já estava aberta ainda aponta para arquivos (chunks) da versão antiga.
export const isChunkError = (err) => {
  const msg = String((err && (err.message || err.name)) || err || '');
  return /ChunkLoadError|Loading chunk [\w-]+ failed|Loading CSS chunk|Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i.test(msg);
};

// Recarrega a página uma única vez (a cada 30 s no máximo) para buscar a versão nova; devolve true se disparou o reload.
export const reloadOnce = () => {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0);
    if (Date.now() - last < 30000) return false;
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()));
  } catch { /* sem sessionStorage: recarrega mesmo assim */ }
  window.location.reload();
  return true;
};

// React.lazy que, se o arquivo da tela não existe mais no servidor (deploy novo), recarrega a página em vez de deixar tela branca.
export const lazy = (factory) => reactLazy(() => factory().catch((err) => {
  if (isChunkError(err) && reloadOnce()) return new Promise(() => {});
  throw err;
}));
